exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-aac24f66]{cursor:pointer;font-size:18px!important}.bg-custom[data-v-aac24f66]{background-color:#f2ff00}.navbar-brand div[data-v-aac24f66]{display:inline-block;vertical-align:middle}.navbar-brand div span[data-v-aac24f66]{color:#f31414}.navbar-brand img[data-v-aac24f66]{vertical-align:middle}.navbar-brand[data-v-aac24f66]{padding-left:1rem;vertical-align:middle;font-size:28px!important}.arabic[data-v-aac24f66]{font-family:Amiri,serif;font-size:28px;vertical-align:bottom}li.nav-item[data-v-aac24f66]{padding:10px}li.nav-item a[data-v-aac24f66]{color:#000!important}li.active[data-v-aac24f66]{background-color:#ff3c3c!important}li.active a[data-v-aac24f66]{color:#f2ff00!important}.nav-item[data-v-aac24f66]:hover{background-color:#f6ff97}.navbar[data-v-aac24f66]{padding:0}button.navbar-toggler[data-v-aac24f66]{margin:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aac24f66","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Navbar.vue
// module id = 33
// module chunks = 0